module.exports = __webpack_public_path__ + "img/erweima_img@2x.927b5a96.png";